import React from 'react';

import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';

import { H2 } from 'view/component/Tipografia/Texto';
import { Conteudo } from 'view/section/Conteudo/Conteudo';

const NotificacoesPage: React.FunctionComponent = () => {
  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem href="/">Início</BreadcrumbItem>
        <BreadcrumbItem>Notificações</BreadcrumbItem>
      </Breadcrumb>

      <Conteudo>
        <H2>Notificações</H2>
        <p>Caso você queira relembrar alguma notificação mais tarde, você pode futuramente marcá-la como não lida.</p>

        <div>Implementar lista de notificações aqui</div>
      </Conteudo>
    </>
  )
}

export default NotificacoesPage;
